import slide4 from "@/assets/images/beforeAfter/item4.png";
import { Button, ButtonType } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

const BeforeAfterQuestion = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  return (
    <div className="flex flex-col justify-center">
      <p className="!m-0 section-title text-center">
        Real Users, Real Results.
      </p>
      <p className="my-3 text-md">
        &quot;I am having the best experience with Skinnyrx! Cyr was so helpful,
        kind & efficient when I had some issues to resolve today. My original
        weight loss goal was 15 lbs. I’m happy to say that I only have 5 more to
        go. Great customer service makes all the difference to me when so many
        companies offer this product.&quot;
        <br />
        <br />— Kelli
      </p>
      <img
        src={slide4}
        className="max-h-[400px] mx-auto"
        alt={"Rachel before after"}
      />

      <Button type={ButtonType.NEXT} onClick={() => setQuestionAnswer(true)} />
    </div>
  );
};

export { BeforeAfterQuestion };
